import { appVersion } from "@fp/ui/env";
import type { AnyRouter } from "@tanstack/react-router";

let deployedVersion: string | null = null;
const listeners = new Set<() => void>();

export function receiveDeployedVersion(version: string): void {
  deployedVersion = version;

  for (const listener of listeners) {
    listener();
  }
}

export function isNewVersionAvailable(): boolean {
  return deployedVersion !== null && deployedVersion !== appVersion;
}

export function subscribeToDeployedVersion(listener: () => void): () => void {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
}

export function loadNewVersionOnNavigation(
  router: AnyRouter,
  loadPage: (href: string) => void = (href) => window.location.assign(href),
): () => void {
  return router.subscribe("onBeforeNavigate", ({ pathChanged, toLocation }) => {
    if (pathChanged && isNewVersionAvailable()) {
      loadPage(toLocation.href);
    }
  });
}
